export class AccessPageModel {
    id?: number;
    name?: string;
    description?: string;
    icon?: string;
    path_name?: string;
    layout?: string;
    collapse?: boolean;
    state?: string;
    order?: number;
    alias?: string;
    parent_id?: number;
    children?: AccessPageModel[];
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;
}